import React from 'react';
import { BulletListBulletIconVariants } from './BulletList';
export const formatPath = (input, isRTL = false) => {
    if (isRTL) {
        return input.reverse().map((value, index) => {
            if (index === 0 && input.length === 1) {
                // left side dot
                return `.${value + 1}`;
            }
            else {
                // right side dot unless it is the last item due to "stylized reasons"
                return `${value + 1}${index === input.length - 1 ? '' : '.'}`;
            }
        });
    }
    else {
        return input.map((value, index) => `${value + 1}${index === input.length - 1 && index > 0 ? '' : '.'}`);
    }
};
const roundOpenBulletListIcon = (React.createElement("svg", { width: "8", height: "8", viewBox: "0 0 8 8", fill: "none" },
    React.createElement("path", { d: "M4 0C3.20888 0 2.43552 0.234596 1.77772 0.674121C1.11992 1.11365 0.607234 1.73836 0.304484 2.46927C0.00173312 3.20017 -0.0774802 4.00444 0.0768607 4.78036C0.231202 5.55629 0.612164 6.26902 1.17157 6.82843C1.73098 7.38784 2.44372 7.7688 3.21964 7.92314C3.99556 8.07748 4.79983 7.99827 5.53074 7.69552C6.26164 7.39277 6.88636 6.88008 7.32588 6.22228C7.76541 5.56448 8 4.79113 8 4C8 2.93913 7.57858 1.92172 6.82843 1.17157C6.07828 0.421427 5.06087 0 4 0ZM4 7C3.40666 7 2.82664 6.82405 2.33329 6.49441C1.83994 6.16476 1.45543 5.69623 1.22836 5.14805C1.0013 4.59987 0.94189 3.99667 1.05765 3.41473C1.1734 2.83279 1.45912 2.29824 1.87868 1.87868C2.29824 1.45912 2.83279 1.1734 3.41473 1.05764C3.99667 0.941889 4.59987 1.0013 5.14805 1.22836C5.69623 1.45542 6.16477 1.83994 6.49441 2.33329C6.82406 2.82664 7 3.40666 7 4C7 4.79565 6.68393 5.55871 6.12132 6.12132C5.55871 6.68393 4.79565 7 4 7Z", fill: "currentColor" })));
const roundClosedBulletListIcon = (React.createElement("svg", { width: "8", height: "8", viewBox: "0 0 8 8", fill: "none" },
    React.createElement("circle", { cx: "4", cy: "4", r: "4", fill: "currentColor" })));
const squareBulletListIcon = (React.createElement("svg", { width: "6", height: "6", viewBox: "0 0 6 6", fill: "none" },
    React.createElement("path", { d: "M8 0H0V8H8V0Z", fill: "currentColor" })));
export const buttonIconOverride = (icon) => {
    switch (icon) {
        case BulletListBulletIconVariants.roundOpen:
            return roundOpenBulletListIcon;
        case BulletListBulletIconVariants.roundClosed:
            return roundClosedBulletListIcon;
        case BulletListBulletIconVariants.square:
            return squareBulletListIcon;
    }
};
export const selectIconBasedOnPath = (level) => {
    switch (level) {
        case 0:
            return roundClosedBulletListIcon;
        case 1:
            return roundOpenBulletListIcon;
        default:
            return squareBulletListIcon;
    }
};
